import type { ROLES } from "./types/enums/roles";
import { ADMIN_URLS, ROLE_BASED_URLS } from "src/routes";

export interface ResolveLandingUrlArgs {
  activeRole: ROLES | null;
  isAdmin: boolean;
  redirect?: string | null;
}

export function resolveLandingUrl({ activeRole, isAdmin, redirect }: ResolveLandingUrlArgs): string | null {
  if (redirect) return redirect;
  if (activeRole) return ROLE_BASED_URLS[activeRole].dashboard;
  if (isAdmin) return ADMIN_URLS.payment.list;
  return null;
}
